import React, { useState } from "react";
import TpaPage from "./Tpa"; 
import PayerPage from "./Payer";
import styles from "./styles/tpaPayer.module.css"; 

const TpaPayerPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"TPA" | "Insurance Company">("TPA");

  return (
    <div className={styles.pageContainer}>
      
      <div className={styles.headerWrapper} data-testid="tpa-payer-page-title">
        <div className={styles.iconCircle}>
          <i className="fa-solid fa-building-shield text-xl"></i>
        </div>
        <h5 className={styles.pageTitle}>
          TPA & Payers
        </h5>
      </div>

      <div className={styles.tabsContainer} data-testid="tpa-payer-page-tabs">
        <button
          onClick={() => setActiveTab("TPA")}
          className={`${styles.tabButton} ${
            activeTab === "TPA" ? styles.activeTab : styles.inactiveTab
          }`}
        >
          
          TPA

        </button>
        
        <button
          onClick={() => setActiveTab("Insurance Company")}
          className={`${styles.tabButton} ${
            activeTab === "Insurance Company" ? styles.activeTab : styles.inactiveTab
          }`}
        >
          Payers
        </button>
      </div>

      <div className={styles.contentArea} data-testid="tpa-payer-page-content">
        {activeTab === "TPA" ? <TpaPage /> : <PayerPage />}
      </div>
    </div>
  );
};

export default TpaPayerPage;